import React from "react";
import styles from "./AboutUs2.module.css";

const AboutUs2 = ({ aboutData }) => {
  if (!aboutData) return null;

  return (
    <section id="about" className={styles.section}>
      <div className={styles.container}>

        <div className={styles.grid}>

          {/* TEXT */}
          <div className={styles.textSide}>
            <span className={styles.badge}>Who We Are</span>

            <h2 className={styles.title}>
              {aboutData.title}
            </h2>

            <p className={styles.description}>
              {aboutData.description}
            </p>

            <div className={styles.stats}>
              <div className={styles.stat}>
                <h3>500+</h3>
                <p>Destinations</p>
              </div>

              <div className={styles.stat}>
                <h3>12+</h3>
                <p>Years Experience</p>
              </div>

              <div className={styles.stat}>
                <h3>24/7</h3>
                <p>Support</p>
              </div>
            </div>

            <button className="btn btn-primary btn-lg mt-4">
              Discover More
            </button>
          </div>

          {/* IMAGE */}
          <div className={styles.imageSide}>
            <img src={aboutData.image} alt="About" className={styles.img}/>
          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutUs2;